import ReactDOM from 'react-dom'
import App from './App'
import "./stylesheet/icons.css"

ReactDOM.render(
  <App />, document.getElementById('root')
)